import React from 'react';

export default class PaginationBase extends React.Component{
    constructor(props) {
        super(props);
        this.action = {}
    }

    _initPagination = async (filter, action) => {
        this.action = action
        this.setState({ pagination: { ...this.state.pagination, loading: true } });
        const pagination = await action(filter);
        if (pagination !== undefined)
            this.setState({ pagination });
        else
            this.setState({ pagination: { ...this.state.pagination, loading: false } });
    };

    _handlePagination = async (filter, complete) => {
        this.setState({ pagination: { ...this.state.pagination, loading: true } });
        filter.field = filter.field === undefined ? '' : filter.field;
        const pagination = await this.action(filter);

        if (pagination !== undefined)
            this.setState({ pagination });
        else
            this.setState({ pagination: { ...this.state.pagination, loading: false } });

        if (complete !== undefined)
            complete();
    };
    
    _handleChangePagination = async (pagination) => {
        const filter = { ...this.state.filter, ...pagination };
        this.setState({ filter });
        this._handlePagination(filter);
    };
}